<template>
  <section class="about-us-banner">
    <MainBanner :heading="heading" :desc="desc" />

  </section>
</template>



<script setup>
import MainBanner from "../Global/MainBanner.vue";
const heading = "About Gill Brother";
const desc = "Looking for reliable plumbing and heating services in the Greater Toronto Area (GTA)? Look no further than Gill Brother Plumbing and Heating Ltd. With our team of highly experienced, dedicated, master, and licensed plumbers, we are your go-to experts for all your plumbing needs.";
</script>

<style scoped>
.about-us-banner {
  background-image: linear-gradient(to right, rgba(0, 29, 51, 0.8), rgba(90, 99, 105, 0.8)), url("../../assets/v-1.1/Banners/about-us-banner.png");
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: 5.5rem;
}
</style>